import {FacilityType} from "types/FacilityType";
import {dateTime} from "services/date";

/**
 * Transform the given facility type by deserializing object properties
 *
 * @internal
 * @param facilityType
 */
export default function deserializeFacilityType(facilityType: any): FacilityType {
    facilityType.created_at = dateTime(facilityType.created_at)
    facilityType.updated_at = dateTime(facilityType.updated_at)

    return facilityType;
}